// NPM Imports
import React from "react";
import { Tooltip } from "../../../revvComponents";

// Components Imports

// Actions Imports

// Services Imports

// Internal Imports
import { DOCUMENTS } from "../../../constants";

// Destructuring
const { DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;

export default function ComponentManageColumnBtn({
  showManageColumnsForTable,
  section,
}) {
  if (
    section.lock === true ||
    (section.data && section.data.data && section.data.data.length === 0)
  ) {
    return null;
  }

  if (section.type === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET) {
    return (
      <Tooltip
        placement="top"
        overlay="Choose table columns you want visible on your document"
        align={{ offset: [0, 3] }}>
        <span
          data-test="documentitems-delete-the-content-btn"
          className="btn-text"
          id="delete-the-content-btn"
          onMouseDown={showManageColumnsForTable}
          onKeyDown={() => {}}
          role="button"
          tabIndex={0}>
          Manage Columns
        </span>
      </Tooltip>
    );
  }

  return null;
}
